import { render } from "./explore-fill.svg?vue&type=template&id=0740a2d5"
const script = {}
script.render = render

export default script